"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageContainer = exports.AppContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styled = _interopRequireDefault(require("./theme/styled"));

var _templateObject, _templateObject2;

var AppContainer = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  width: 100%;\n  min-height: 200px;\n  background-color: ", ";\n  display: flex;\n  flex: 1 0 auto;\n  flex-direction: column;\n"])), function (p) {
  return p.theme.bgColor;
});

exports.AppContainer = AppContainer;

var PageContainer = _styled.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex: 1 0 auto;\n  justify-content: center;\n  align-items: flex-start;\n  position: relative;\n\n  & > div:first-of-type {\n    min-height: 100%;\n    width: 100% !important;\n  }\n  * {\n    box-sizing: border-box;\n  }\n"])));

exports.PageContainer = PageContainer;